import { OfferFragment } from '@occc/graphql';
import { constraintHelper } from '@occc-app/offerHelpers/utils/constraintHelper';
import { UnitedStates } from '@occc-app/lib/constants';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import { makeCreateInStatesConstraintOperation } from '@occc-app/offerHelpers/operations/constraints';

import { LocationInStateConstraintFormValues, UnitedState } from './types';

export const getLocationInStateConstraintInitialValues = (
  offer: OfferFragment | null | undefined,
): LocationInStateConstraintFormValues => {
  const inStatesConstraint = offer?.constraints.find(constraintHelper.isLocationInState);

  const states = inStatesConstraint?.states
    .map((id) => UnitedStates.find((state) => state.id === id))
    .filter(Boolean) as UnitedState[];

  return {
    inStates: inStatesConstraint
      ? {
          id: inStatesConstraint.id,
          states,
        }
      : {},
  };
};

export const getLocationInStateConstraintOperations = (
  offerId: string,
  _offer: OfferFragment | undefined,
  values: LocationInStateConstraintFormValues,
  dirtyFields: DirtyFieldsType,
): Operation[] => {
  const operations: Operation[] = [];

  if (isFieldDirty<LocationInStateConstraintFormValues>(dirtyFields, 'inStates.states')) {
    if (values.inStates?.id) {
      operations.push(makeDeleteOperation('constraintDelete', values.inStates.id));
    }
    if (values.inStates?.states?.length) {
      const states = values.inStates.states.map((s) => s.id);
      operations.push(makeCreateInStatesConstraintOperation(offerId, states));
    }
  }

  return operations;
};
